<template>
	<div>
		<!-- <NuxtLoadingIndicator color="#F59E0B" :height="5" /> -->

		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
	</div>
</template>